import React from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from '../_shared/index.js';
import ManageMilestonesContainer from './ManageMilestonesContainer.jsx';

function ManageMilestonesComponent() {
	const currentUser = useSelector((state) => state.user.currentUser);

	if (!currentUser?.company) return <Spinner />;

	return <ManageMilestonesContainer currentUser={currentUser} />;
}

export default ManageMilestonesComponent;
